import ProductV2 from './ProductV2'

export {
  ProductV2
}

export default ProductV2
